import type { ChangeEvent, FC } from "react";
import { useState } from "react";
import { useOrderTodos } from "./useOrderTodos";
import type { SavedOrder } from "../orderTypes";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { labelForTodoItem, todoItemsOrder } from "./labelForTodoItem";

interface Props {
  readonly orderId: string;
  readonly todos: SavedOrder["todos"];
}

const UpdateableOrderTodos: FC<Props> = ({ orderId, todos }) => {
  const { onUpdateTodos } = useOrderTodos(orderId);
  const [isLoading, setIsLoading] = useState(false);

  if (!todos) {
    return null;
  }

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const updatedTodos = { ...todos, [event.target.name]: event.target.checked };
    try {
      setIsLoading(true);
      await onUpdateTodos(updatedTodos);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormControl disabled={isLoading} sx={{ m: 3 }} component="fieldset" variant="standard">
      {todoItemsOrder.map((key) => (
        <FormControlLabel
          key={key}
          control={<Checkbox checked={todos[key]} onChange={handleChange} name={key} />}
          label={labelForTodoItem(key)}
        />
      ))}
    </FormControl>
  );
};

export default UpdateableOrderTodos;
